export const study = {
  id: 'reading-study-mvp',
  version: 1,
  title: '읽기와 이해도 연구',
  instructions: '자료를 읽은 뒤 이해도 문항에 답해주세요. 문항은 한 번에 하나씩 제시되며, 제출한 문항으로 돌아갈 수 없습니다. 문항 화면에서 읽기 자료를 다시 확인할 수 있습니다.',
  // 현재 MVP는 아래 설정만 지원합니다. 다른 조건은 후속 구현에서 사용합니다.
  presentation: { taskMode: 'sequential', readingMode: 'full', allowBack: false, required: true },
  materials: [
    {
      id: 'urban-trees',
      title: '도시의 나무와 생활 환경',
      paragraphs: [
        '도시의 나무는 거리의 풍경을 바꿀 뿐 아니라 생활 환경에도 영향을 준다. 나무의 잎과 가지는 햇빛을 가려 지표면이 지나치게 뜨거워지는 것을 줄인다. 또한 잎에서 물이 증발하는 과정은 주변의 열을 흡수한다.',
        '나무를 심는 것만으로 모든 문제가 해결되지는 않는다. 나무가 건강하게 자라려면 뿌리가 뻗을 공간과 충분한 물이 필요하다. 지역의 기후와 토양에 맞는 나무를 선택하고 꾸준히 관리하는 일도 중요하다.',
        '따라서 도시의 녹지 계획은 나무의 수뿐 아니라 위치와 관리 방법도 함께 고려해야 한다. 주민이 자주 이용하는 길과 휴식 공간에 적절한 녹지를 마련하면 더 많은 사람이 그 효과를 누릴 수 있다.'
      ],
      questions: [
        { id: 'cooling', type: 'singleChoice', prompt: '글에서 설명한 나무의 역할은 무엇인가요?', options: [ { value: 'shade', label: '그늘을 만들고 물의 증발을 통해 주변 열을 줄인다.' }, { value: 'soil', label: '토양과 기후를 완전히 바꾼다.' }, { value: 'water', label: '물을 공급하지 않아도 주변 온도를 낮춘다.' } ] },
        { id: 'planning', type: 'text', prompt: '도시의 녹지를 계획할 때 나무의 수 외에 고려해야 하는 점을 설명해주세요.' },
        { id: 'feedback', type: 'text', prompt: '이 과제에 대한 소감을 입력해주세요.' }
      ]
    }
  ]
};
